module.exports = __webpack_public_path__ + "img/1_02.fc04c337.png";